import { LOADING } from "../../Actions/Types";
import {SendCheckerIntergateEmailApi, CheckStatusCheckerIntergateEmailApi, EditCheckerIntergateEmailApi } from "../../Api/AccessibilityCheckerAPI";

// service to send intergation email to user
const sendIntergationEmailService = (
    accessToken: string, // access token
    email: string, // email
    langCode: string, // language code,
    dispatch:Function,
    setIntegrationRequestId:Function,
    backgroundColor?:string,
    title?:string,
    style?:string,
) => {

    dispatch({
        type: LOADING,
        payload: true,
    });
    // API to send email
    SendCheckerIntergateEmailApi(accessToken, email, langCode, backgroundColor, title, style).then(response => {
        // check response data is available
        if (response.Data) {
            dispatch({
                type: LOADING,
                payload: false,
            });
            setIntegrationRequestId(response.Data?.id)
        }
    })
}

// service to send intergation email to user
const CheckStatusIntergationEmailService = async (
    PID: string, // access token
) => {

    // API to send email
    const response = await CheckStatusCheckerIntergateEmailApi(PID)
    return response; // return the data you want
}

// service to send intergation email to user
const EditIntergationEmailService = (
    accessToken: string, // access token
    email: string, // email
    id: string, // language code
    dispatch:Function,
    setIntegrationRequestId:Function,
    backgroundColor?:string,
    title?:string,
    style?:string
) => {

    dispatch({
        type: LOADING,
        payload: true,
    });
    // API to send email
    EditCheckerIntergateEmailApi(accessToken, email, id, backgroundColor, title, style).then(response => {
        // check response data is available
        if (response.Data) {
            dispatch({
                type: LOADING,
                payload: false,
            });
            setIntegrationRequestId(response.Data?.id)
        }
        return response.Data
    })
}

export {sendIntergationEmailService, CheckStatusIntergationEmailService, EditIntergationEmailService}